import { action } from 'typesafe-actions';
import { TAXES_FAILURE, TAXES_REQUEST, TAXES_SUCCESS } from '../../constants/pricing';


export const taxesRequestAction = () => action(TAXES_REQUEST);
export const taxesSuccessAction = (data: any) => action(TAXES_SUCCESS, data);
export const taxesFailureAction = (e: any) => action(TAXES_FAILURE, e);

export const PricingActions = {
    taxesRequestAction,
    taxesSuccessAction,
    taxesFailureAction,
  };
  